import debounce from '../../../methods/debounce'
import currencyFormatter from '../../../methods/currencyFormatter'
import verifyLabel from '../../../methods/verifyLabel'

const dispatchAmount = debounce(function(payload, store) {
    store.dispatch("cart/getChangedQuantity", payload)
}, 500)

export default {
    name: 'checkout-line',
    data(){
        return {
            localQuantity: 0,
            displayQuantity: 0,
            displayItem: true,
            productAmount: 0,
            productCode: undefined,
            productHasDiscount: false
        }
    },
    props: {
        lineData: Object,
        itemCountInCart: Number
    },
    computed:{
        getCart() {
            return this.lineData
        },
        labels() {
            return this.$store.state.cart.checkoutCart.labels
        },
        discountedProduct() {
            return (this.lineData.orderAmount.amount !== (this.lineData.placedPrice.amount*this.lineData.quantity))
        },

        singlePriceDiscount() {
            return currencyFormatter(this.lineData.orderAmount.currency, (this.lineData.orderAmount.amount / this.lineData.quantity))
        },
        singleProductPrice() {
            return currencyFormatter(this.lineData.placedPrice.currency, this.lineData.placedPrice.amount)
        },
        totalPriceDiscount() {
            return currencyFormatter(this.lineData.orderAmount.currency, (this.lineData.placedPrice.amount * this.lineData.quantity))
        }, 
        totalProductPrice() {
            return currencyFormatter(this.lineData.orderAmount.currency, this.lineData.orderAmount.amount)
        },
        scrollbarMargin() {
            return (this.itemCountInCart > 3)
        }
    },
    methods: {
        // Ensure Matomo cart reflects the absolute quantity for this SKU
        trackMatomoItemQuantity(code, quantity) {
            try {
                if (window && window._paq) {
                    window._paq.push(['removeEcommerceItem', code]);
                    if (quantity > 0) {
                        window._paq.push(['addEcommerceItem', code, this.getCart.displayName, null, parseFloat(this.getCart.placedPrice), quantity]);
                    }
                }
            } catch (e) {
                // no-op
            }
        },
        incrementAmount() {
            this.displayQuantity += 1
            const code = this.productCode || this.getCart.code
            this.trackMatomoItemQuantity(code, this.displayQuantity)

            const payload = {
                code : code,
                quantity : this.displayQuantity
            }
            dispatchAmount(payload, this.$store)
        },
        decrementAmount() {
            const code = this.getCart.code
            this.displayQuantity = this.displayQuantity ? this.displayQuantity - 1 : 0
            this.trackMatomoItemQuantity(code, this.displayQuantity)

            const payload = {
                code : code,
                quantity : this.displayQuantity
            }
            dispatchAmount(payload, this.$store)
        },
        removeProduct() {
            const code = this.getCart.code
            this.displayQuantity = 0
            this.trackMatomoItemQuantity(code, 0)

            const payload = {
                code : code,
                quantity : this.displayQuantity
            }
            dispatchAmount(payload, this.$store)
        },
        changeAmount() {
            const code = this.getCart.code
            const newAmount = Number.isInteger(+this.displayQuantity) ? +this.displayQuantity : 0
            this.displayQuantity = newAmount
            this.trackMatomoItemQuantity(code, newAmount)

            const payload = {
                code : code,
                quantity : this.displayQuantity
            }
            dispatchAmount(payload, this.$store)
        },
        verifyLabel(displayName) {
            if (this.$store.state.cart.checkoutCart.labels) {
                return verifyLabel(displayName,this.$store.state.cart.checkoutCart.labels)
            } else {
                return ""
            }
        }
    },
    mounted() {
        this.displayQuantity = this.getCart.quantity
        this.productCode = this.getCart.code
        this.currentItemInCartCount = this.itemCountInCart
    },
    updated() {
        const productCodeChanged = !!(this.getCart.code !== this.productCode)
        const cartItemCountChanged = !!(this.itemCountInCart !== this.currentItemInCartCount)

        if(cartItemCountChanged || productCodeChanged){
            this.displayQuantity = this.getCart.quantity
            this.currentItemInCartCount = this.itemCountInCart
        }
        
    }
}


